import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dw-cluster-marker" }
const _hoisted_2 = { class: "dw-cluster-marker__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "dw-cluster-marker__content",
      style: _normalizeStyle(_ctx.computedStyles)
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.number), 1)
    ], 4)
  ]))
}